export default __webpack_public_path__ + "static/media/recentIcon.e65a6569.svg";